'use client';

import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import { useEffect } from 'react';
import classNames from 'classnames';
import Heading from 'src/components/Heading/Heading';
import CardProduct from 'src/components/Card/CardProduct';
import styles from './section-with-products.module.scss';

/**
 * @typedef {import("@prismicio/client").Content.SectionWithProductsSlice} SectionWithProductsSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<SectionWithProductsSlice>} SectionWithProductsProps
 * @param { SectionWithProductsProps }
 */
const SectionWithProducts = ({ slice }) => {
    const [productData, setProductData] = React.useState(null);

    useEffect(() => {
        if (!slice.items || !slice.items.length) return;
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({
                query: slice.items.map((item) => item.product.id),
            }),
            headers: {
                'Content-Type': 'application/json',
                charset: 'utf-8',
            },
            redirect: 'follow',
        };
        fetch('/prismic/api/get-type-by-ids', requestOptions)
            .then((response) => response.json())
            .then((data) => {
                data.results.length && setProductData(data.results);
            });
    }, []);

    return (
        <section
            className="py-8 md:py-16"
            style={{ backgroundColor: slice.primary.background || 'bg-white' }}
        >
            <div className="container">
                <div className="mx-auto mb-8 w-full max-w-2xl text-center">
                    <Heading level={'h2'} centered={true}>
                        {slice.primary.title}
                    </Heading>
                    <PrismicRichText field={slice.primary.description} />
                </div>
                {productData && (
                    <div
                        className={classNames(
                            styles['products'],
                            `xl:grid-cols-${productData.length}`,
                        )}
                        data-products-count={productData.length}
                    >
                        {productData.map((item) => {
                            return (
                                <CardProduct
                                    {...item.data}
                                    key={item.id}
                                    className={styles['product']}
                                    location={slice.slice_type}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
};

export default SectionWithProducts;
